/**
 * WSR Solutions JavaScript & CSS library.
 *
 * @author Wouter Schotman <wouter@ideemedia.nl>
 * @copyright IdeeMedia.nl
 */

import "../scss/style.scss";
import { sliders } from "./sliders";
import { onScroll } from "./scroll";
import { newsletter } from "./newsletter";
import { resellers } from "./resellers";
import { videoModal } from "./video-modal";

function windowSize(){
    if(document.documentElement.clientWidth >= 992)
        document.body.classList.remove('is-nav-open');
}

function init() {
    window.addEventListener("resize", windowSize);
    window.addEventListener("scroll", onScroll, {passive: true});
}

windowSize();
sliders();
newsletter();
resellers();
videoModal();
init();